/**
 * @module app.shared
 */

export class TestIdValueConverter {

    /**
     * Build a `test-id` value with the given `prefix`, falling back on `defaultValue` if necessary
     *
     * **Example:** `testName : 'btn' : type`
     * - If `testName` is specified, the result will be: `btn-${testName}`
     * - If `testName` is not specified, the result will be: `btn-${type}`
     *
     * @param value a name for the element to use as part of the `test-id`
     * @param prefix a prefix for the element type, like `'btn'` or `'txt'`
     * @param defaultValue the default name to use for the element if `name` isn't specified
     */
    public toView(value: unknown, prefix: unknown, defaultValue: unknown): string {
        const actual = value || defaultValue;
        if(actual) {
            return `${prefix}-${actual}`;
        }
        return '';
    }

}
